"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = exports.ICON_TYPE = exports.ICON_SIZE = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _typographyModule = _interopRequireDefault(require("../../styles/typography.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ICON_TYPE = Object.freeze({
  regular: 'regular',
  solid: 'solid',
  duotone: 'duotone',
  brands: 'brands'
});
exports.ICON_TYPE = ICON_TYPE;
const ICON_SIZE = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large'
});
exports.ICON_SIZE = ICON_SIZE;
const Icon = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    type = 'regular',
    name = '',
    size = 'medium',
    color = _typography.TEXT_COLORS.primary,
    className,
    style,
    onClick,
    swapOpacity
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!name && /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_typographyModule.default.centerAlignFlex, _typographyModule.default[`${size}Icon`], _typographyModule.default[color], className),
    onClick: onClick,
    ref: forwardRef
  }, /*#__PURE__*/React.createElement("i", {
    className: (0, _classify.default)(`fa-${type} fa-${name} `, {
      ['fa-swap-opacity']: swapOpacity
    }),
    style: style
  })));
});
exports.Icon = Icon;